// Wake Forest University's undergraduate majors (#2652). Read on 2026-10-01
// from the official 2026-2027 Academic Bulletin's Requirements for Degrees
// page, which names every major that leads to the Bachelor of Arts and the
// Bachelor of Science in Wake Forest College, and the four Bachelor of
// Science majors in the School of Business. Names are the bulletin's, set in
// title case (it writes them in lowercase); the degree is the bulletin's
// (Bachelor of Arts = BA, Bachelor of Science = BS). Majors offered for both
// degrees appear once per degree. Decision analytics is listed both as a
// College BS and as a School of Business BS, so it appears in both groups.
// Minors and graduate programs are left out. The KB's majors list was the
// starting point; the bulletin wins.
const majors = {
    "slug": "wake-forest-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Wake Forest's 2026-2027 Academic Bulletin, grouped by the school that offers it, with the degree it leads to. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Wake Forest College (arts and sciences)",
            "source": {
                "label": "Wake Forest 2026-2027 Academic Bulletin, Requirements for Degrees",
                "url": "https://bulletin.wfu.edu/undergraduate/requirements-degrees/"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chinese Language and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Classical Languages",
                    "degree": "BA"
                },
                {
                    "name": "Classical Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Critical and Creative Media",
                    "degree": "BA"
                },
                {
                    "name": "Decision Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BA"
                },
                {
                    "name": "Engineering",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environment and Sustainability Studies",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BA"
                },
                {
                    "name": "French Studies",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "German Studies",
                    "degree": "BA"
                },
                {
                    "name": "Greek",
                    "degree": "BA"
                },
                {
                    "name": "Health and Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Japanese Language and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Latin",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Politics and International Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Studio Art",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Business",
            "source": {
                "label": "Wake Forest 2026-2027 Academic Bulletin, Requirements for Degrees",
                "url": "https://bulletin.wfu.edu/undergraduate/requirements-degrees/"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "BS"
                },
                {
                    "name": "Business and Enterprise Management",
                    "degree": "BS"
                },
                {
                    "name": "Decision Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
